"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_app__anytime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#333;stroke-linecap:round;stroke-width:8px;}.cls-1{stroke-linejoin:round;}.cls-2{stroke-miterlimit:10;}")), /*#__PURE__*/React.createElement("title", null, "APP_anytime"), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152,22.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152,23.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.07,82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133,91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52,65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "64.4 71.82 72.54 64 72.54 51.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.6 63.23 44.21 71.83 52.82 63.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.32,83.91a28.16,28.16,0,1,0-8.22-18.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82,
    y1: 124,
    x2: 92,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    id: "b493255f-edd2-469b-8f82-6d8f944da046",
    className: "cls-2",
    x1: 103.37,
    y1: 108,
    x2: 80.63,
    y2: 108
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113,124H31.37C25.09,124,20,118.63,20,112V32c0-6.63,5.09-12,11.37-12H152.63C158.91,20,164,25.37,164,32V81.81"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_39bbb6be-0d7a-4bfa-8252-1f40bf874658",
    "data-name": "39bbb6be-0d7a-4bfa-8252-1f40bf874658"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.79,
    y1: 156,
    x2: 150.74,
    y2: 156
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.64,84h40.72c4.22,0,7.64,3.11,7.64,7v74.1c0,3.84-3.42,6.95-7.64,6.95H123.64c-4.22,0-7.64-3.11-7.64-6.95V91C116,87.11,119.42,84,123.64,84Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 192,
    height: 192
  }));
}

var _default = ic_app__anytime;
exports.default = _default;